import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import { getSelectOptions, getRadioOptions } from 'src/reducers/selectOptions';
import selector, { getOptionLabel, display } from 'src/utils/Utils';
import { formatDate } from 'src/utils/Date';
import tableStyles from '../styles/GeneralTableInfo.scss';
import EmployeeLeaveOfAbsenceItemShow from '../containers/EmployeeLeaveOfAbsenceItemShow';
import { useTranslation } from 'react-i18next';

const BusinessInfoSectionShow = props => {
  const {
    employee,
    groups,
    positions,
    occupations,
    employmentTypes,
    enrollmentStatuses,
    resignedReasons,
    employeeLeaveOfAbsences,
    client,
    clientBranch,
    resignTaxOptions
  } = props;

  const { t } = useTranslation();
  const belong_office = clientBranch.map(data => (
    { value: data.id, label: data.officeName }
  ))
  belong_office.unshift({ value: -1, label: client.officeName });
  return (
    <div>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.staff_code')}：</th>
            <td>{display(employee.staffCode)}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.belong')}：</th>
            <td>{display(getOptionLabel(employee.clientBranchId)(belong_office))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.employment_type')}：</th>
            <td>{display(getOptionLabel(employee.employmentTypeId)(employmentTypes))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.position')}：</th>
            <td>{display(getOptionLabel(employee.positionId)(positions))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.occupation')}：</th>
            <td>{display(getOptionLabel(employee.occupationId)(occupations))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.group')}：</th>
            <td>{display(getOptionLabel(employee.groupId)(groups))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.employment_status')}：</th>
            <td>{display(getOptionLabel(employee.enrollmentStatus)(enrollmentStatuses))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.first_day_of_work')}：</th>
            <td>{display(formatDate(employee.joinedOn))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BusinessInfoSection.retirement_date')}：</th>
            <td>{display(formatDate(employee.resignedOn))}</td>
          </tr>
          {employee.resignedOn && (
            <tr>
              <th>{t('features.Employees.components.BusinessInfoSection.retirement_division')}：</th>
              <td>{display(getOptionLabel(employee.resignedReason)(resignedReasons))}</td>
            </tr>
          )}

          {employee.resignedOn && (
              <tr>
                <th>{t('features.Employees.components.BusinessInfoSection.resign_tax_options')}：</th>
                <td>{display(getOptionLabel(employee.resignTaxOption)(resignTaxOptions))}</td>
              </tr>
          )}

          {!_.isEmpty(employeeLeaveOfAbsences) && <EmployeeLeaveOfAbsenceItemShow {...{ employeeLeaveOfAbsences }} />}
        </tbody>
      </table>
    </div>
  );
};
export default connect(state => ({
  employee: selector(getItem(REDUCER_NAME, state), 'employee'),
  groups: getSelectOptions(state, 'groups'),
  positions: getSelectOptions(state, 'positions'),
  occupations: getSelectOptions(state, 'occupations'),
  employmentTypes: getSelectOptions(state, 'employmentTypes'),
  enrollmentStatuses: getSelectOptions(state, 'enrollmentStatuses'),
  resignedReasons: getRadioOptions(state, 'resignedReasons'),
  employeeLeaveOfAbsences: getSelectOptions(state, 'employeeLeaveOfAbsences'),
  client: getSelectOptions(state, 'client'),
  clientBranch: getSelectOptions(state, 'clientBranch'),
  resignTaxOptions: getRadioOptions(state, 'resignTaxOptions')
}))(BusinessInfoSectionShow);
